<style scoped lang="scss">
.toc {
  background: white;
  padding: 10px 25px;
  display: flex;
  flex-direction: column;
  border-bottom: 1px solid #eeee;
  font-weight: bold;
  a {
    font-size: 90%;
  }
}
.stickyTab .ivu-tabs > .ivu-tabs-bar {
  margin-bottom: 0;
}
.p-marginer > p {
  padding-bottom: 10px;
}

.volunteer-container {
  display: flex;
  flex-direction: column;
}

.field-container {
  margin-bottom: 10px;
  display: flex;
}

.field-container > .label {
  min-width: 130px;
}

.field-container > .field {
  width: 100%;
}

.group-avatar {
  cursor: pointer;
  height: 60px;
  width: 60px;
  background-repeat: no-repeat;
  background-position: center center;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
  position: relative;
}
.group-avatar-important {
  height: 88px !important;
  width: 88px !important;
  top: 6px;
  left: 6px;
}
.has-margin-bottom {
  margin-bottom: 5px;
}

.upload-avatar {
  height: 40px;
  width: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #000000cf;
  position: absolute;
  border-radius: 50%;
  top: -10px;
  right: -13px;
}

.upload-avatar > button {
  color: #fff;
  font-size: 2em;
}

.header-loader {
  width: 60px;
  height: 60px;
  background: #eaeaea;
  border-radius: 10%;
}

.content-loader > .content-1 {
  height: 18px;
  width: 170px;
  background: #eaeaea;
  border-radius: 4px;
}

.content-loader > .content-2 {
  height: 20px;
  width: 125px;
  background: #eaeaea;
  border-radius: 3px;
  margin-top: 10px;
}

.title-margin {
  margin-left: 70px;
  width: calc(100% - 70px);
}

.clamp-text-description {
  /* max-width: 275px !important; */
  /* min-width: 75vw; */
  width: 100%;
  display: -webkit-box;
  -webkit-line-clamp: 2 !important;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
</style>

<style lang="scss">
.bookmark-action {
  width: 32px;
  display: flex !important;
  height: 32px;
  justify-content: center;
  span {
    position: absolute;
    top: 4px;
  }
}
.document-avatar {
  height: 60px;
  width: 60px;
  max-width: 60px !important;
  // background: #888888;
  position: absolute !important;
  background-repeat: no-repeat;
  background-size: cover;
  /* margin-bottom: 10px; */
  img {
    height: 60px;
    width: 60px;
  }
}
.hide-ivu-tabs-nav-scroll {
  .ivu-tabs-bar,
  .ivu-tabs-nav-scroll {
    height: 0 !important;
  }
}
.ivu-tabs-nav-wrap.ivu-tabs-nav-scrollable {
  margin-left: 15px;
  margin-right: 15px;
}

.invite-content-container > .ivu-radio-group {
  display: flex;
  flex-direction: column;
}

.invite-content-container
  > .ivu-radio-group
  > label.ivu-radio-wrapper.ivu-radio-group-item {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
  border-bottom: 1px solid #eee;
  padding-bottom: 10px;
  flex-direction: row-reverse;
}

.no-highlight.ivu-btn:focus {
  box-shadow: none;
}

.no-highlight.ivu-btn-default.ivu-btn.active,
.no-highlight.ivu-btn-default.ivu-btn:active {
  border-color: #dddee1;
  color: #495060;
}

.no-highlight.ivu-btn-default.ivu-btn.hover,
.no-highlight.ivu-btn-default.ivu-btn:hover {
  border-color: #dddee1;
  color: #495060;
}
.lp {
  padding: 20px;
  line-height: 55px;
  background: #ecececf2;
}
.iframe-stl-survey {
  width: 100%;
  border: 0;
  position: sticky;
  top: 0;
  height: calc(100vh - 84px - 60px);
  z-index: 1;
}

.citation br {
  display: unset !important;
}
</style>

<template>
  <AppLayout class="resources-single-page-template" v-if="singleResource">
    <div v-if="showSurveyIFrame" style="position: relative">
      <img
        @click="showSurveyIFrame = false"
        class="pointer"
        style="z-index: 2;height:25px; width:25px;position:absolute;top:0;right:0;margin:10px 10px 0 0;"
        src="@/assets/close.png"
      />
      <iframe class="iframe-stl-survey" :src="singleResource.data.data.survey_url_end"></iframe>
    </div>
    <Row v-else type="flex" justify="center">
      <Col :span="24">
        <div
          v-if="!resourceLoading"
          :style="{backgroundImage: 'url('+moduleCoverPhoto+')'}"
          style="height: 120px; background-attachment: local;background-repeat: no-repeat;background-position: 50%;background-size: 100% auto;overflow:hidden;position:relative"
        >
          <div
            style="display: flex; flex-direction: column; justify-content: center; position:absolute;left:0;top:0;height:100%;width:100%;background:rgba(0,0,0,.30)"
          >
            <span style="padding-left:15px;color:white;font-size:20px;line-height:100px">
              <b>{{singleResource.data.title}}</b>
            </span>
          </div>
        </div>
        <div v-else>
          <vue-content-loading :width="300" :height="100" style="background: #e8e7e7;">
            <!-- <rect x="0" y="0" rx="0" ry="0" width="130" height="130" /> -->
            <rect x="15" y="40" width="220" height="20" />
          </vue-content-loading>
        </div>
        <!-- <Card 
                  shadow 
                  :style="{borderRadius: '0'}" 
                  :padding="0">
                  
                  <Row type="flex" style="padding: 20px" v-else>
                      <div class="header-loader" style="margin-left"></div>
                      <div class="content-loader">
                        <div class="content-1" style="height: 18px; margin-left: 10px; margin-top:22px"></div>
                       
                      </div>
                  </Row>
        </Card>-->
        <Row type="flex" justify="center">
          <Col :span="24" v-if="viewSettings && !resourceLoading">
            <Tabs :animated="false" v-model="tabNameEdit" @on-click="onEditTabClick">
              <TabPane label="Manage" name="manage">
                <ManageGroupComponent></ManageGroupComponent>
              </TabPane>
              <TabPane label="Moderation" name="moderation">
                <ModerationComponent
                  :isAdmin="(!checkIfCreator(singleResource.data.submitted_by) || isUserAdmin(singleResource.data))"
                ></ModerationComponent>
              </TabPane>
            </Tabs>
          </Col>
          <Col :span="24" v-if="!viewSettings">
            <Affix v-if="!isHideTabs" :offset-top="offsetNo" @on-change="change">
              <div class="stickyTab" v-if="stickTabs" style="background:#f0f0f0">
                <transition name="mfade">
                  <Tabs :animated="false" v-model="tabName" @on-click="onTabClick">
                    <TabPane
                      label="Course"
                      name="course"
                      v-if="singleResource.data.type !== 'badge'"
                    ></TabPane>
                    <TabPane
                      label="Additional Resources"
                      name="documents"
                      v-if="singleResource.data.type !== 'badge' && !isLoadingDocs && !resourceLoading && moduleDocs.length >= 1"
                    ></TabPane>
                  </Tabs>
                </transition>
              </div>
            </Affix>
            <div v-if="selectedDoc">
              <Modal
                :footer-hide="true"
                v-model="showDocInfo"
                :title="selectedDoc.title"
                @on-cancel="selectedDoc = null"
              >
                <p
                  class="citation compound-text"
                  style="padding: 10px"
                  v-html="onPreviewText(selectedDoc.data.tip)"
                />
                <div v-if="!isBroadcast" style="display: flex; justify-content: center;">
                  <Button shape="circle" @click="bookmarkItem(selectedDoc)" :disabled="isBookmarkingDoc" :loading="isBookmarkingDoc" class="bookmark-action">
                    <img
                      style="height: 15px; width: 15px;"
                      v-if="!isBookmarkingDoc"
                      :src="selectedDoc.bookmarked ? bookmarkSolidImg : bookmarkImg"
                    />
                  </Button>
                </div>
              </Modal>
            </div>
            <Tabs v-if="!isHideTabs" :animated="false" v-model="tabName" @on-click="onTabClick">
              <TabPane label="Course" name="course" />
              <TabPane
                label="Additional Resources"
                name="documents"
                v-if="!isLoadingDocs && !resourceLoading && moduleDocs.length >= 1"
              />
            </Tabs>
            <div v-show="tabName == 'course'">
              <div v-if="!isElementsLoading && !resourceLoading">
                <div class="toc" v-if="hasTOC">
                  <div style="color: #404040;">Table of Contents</div>
                  <a v-for="(page, i) in tocs" :key="i" @click="scrollTo(page.id)">
                    {{ `${i+1}. ${page.title}` }}
                  </a>
                </div>
                <CourseListComponent
                  ref="courses"
                  :isAdmin="(!checkIfCreator(singleResource.data.submitted_by) || isUserAdmin(singleResource.data))"
                  :section="'group'"
                  :items="myPages"
                />
                <ModuleBottomComponent
                  :moduleId="singleResource.data.id"
                  @openSurveyIFrame="onShowSurveyIFrame"
                  :contactInfo="courseContactInfo"
                  :surveyInfo="singleResource.data.data.survey_url_end"
                  :isFloating="isFloatingModule"
                />
              </div>
              <div
                v-else
                style="background: white; height: 80vh; padding-top: 20px; display: flex; flex-direction: column"
              >
                <vue-content-loading :width="300" :height="150">
                  <rect x="10" y="5" width="280" height="200" />
                </vue-content-loading>
                <vue-content-loading :width="300" :height="25">
                  <rect x="10" y="5" width="210" height="200" />
                </vue-content-loading>
                <vue-content-loading :width="300" :height="25">
                  <rect x="10" y="5" width="250" height="200" />
                </vue-content-loading>
                <vue-content-loading :width="300" :height="25">
                  <rect x="10" y="5" width="270" height="200" />
                </vue-content-loading>
                <vue-content-loading :width="300" :height="25">
                  <rect x="10" y="5" width="250" height="200" />
                </vue-content-loading>
                <vue-content-loading :width="300" :height="25">
                  <rect x="10" y="5" width="270" height="200" />
                </vue-content-loading>
              </div>
            </div>
            <div
              v-show="tabName == 'documents' && !isLoadingDocs && !resourceLoading && moduleDocs.length >= 1"
              style="overflow:hidden;width:100%"
            >
              <div v-if="!isLoadingDocs && !resourceLoading">
                <div style="background: white;">
                  <!-- <CitationItem
                    @showCitation="selectedDocItem"
                    v-if="hasCitationId"
                    :citation="hasCitationId"
                  />-->
                  <div
                    v-if="!moduleDocs || (moduleDocs && moduleDocs.length < 1)"
                    style="color:#aaa;text-align:center;padding:20px"
                  >No Additional Resources Found</div>
                  <div
                    style="border-bottom:1px solid #ddd; padding: 10px; align-items: center;"
                    v-for="item in moduleDocs"
                    class="pointer"
                    :key="(item.id) ? item.id : item.activity_id"
                    :style="{
                              display: getDisplayImage(item) ? 'flex':'',
                              minHeight: removeHTMLTags(item.data.tip) ? '0px' : '80px'
                            }"
                    @click="documentClick(item)"
                  >
                    <progressive-img
                      class="document-avatar"
                      v-if="getDisplayImage(item)"
                      :src="getDisplayImage(item)"
                    />
                    <div :class="getDisplayImage(item)? 'title-margin':''">
                      <strong class="pointer">{{item.title}}</strong>
                      <br />
                      <span class="clamp-text-description">{{ item.data.tip | getTextFromHTML }}</span>
                    </div>
                  </div>
                </div>
                <ModuleBottomComponent
                  :moduleId="singleResource.data.id"
                  @openSurveyIFrame="onShowSurveyIFrame"
                  :contactInfo="courseContactInfo"
                  :surveyInfo="singleResource.data.data.survey_url_end"
                  :isFloating="isFloatingModule"
                />
              </div>
              <div v-else style="background: white; height: 80vh;">
                <vue-content-loading :width="300" :height="60">
                  <rect x="8" y="5" width="60" height="60" />
                  <rect x="72" y="5" width="150" height="15" />
                  <rect x="72" y="25" width="110" height="15" />
                  <rect x="72" y="45" width="80" height="15" />
                </vue-content-loading>
                <vue-content-loading :width="300" :height="60">
                  <rect x="8" y="5" width="60" height="60" />
                  <rect x="72" y="5" width="190" height="15" />
                  <rect x="72" y="25" width="200" height="15" />
                  <rect x="72" y="45" width="90" height="15" />
                </vue-content-loading>
                <vue-content-loading :width="300" :height="60">
                  <rect x="8" y="5" width="60" height="60" />
                  <rect x="72" y="5" width="200" height="15" />
                  <rect x="72" y="25" width="170" height="15" />
                  <rect x="72" y="45" width="180" height="15" />
                </vue-content-loading>
                <vue-content-loading :width="300" :height="60">
                  <rect x="8" y="5" width="60" height="60" />
                  <rect x="72" y="5" width="50" height="15" />
                  <rect x="72" y="25" width="10" height="15" />
                  <rect x="72" y="45" width="180" height="15" />
                </vue-content-loading>
                <vue-content-loading :width="300" :height="60">
                  <rect x="8" y="5" width="60" height="60" />
                  <rect x="72" y="5" width="200" height="15" />
                  <rect x="72" y="25" width="210" height="15" />
                  <rect x="72" y="45" width="40" height="15" />
                </vue-content-loading>
                <vue-content-loading :width="300" :height="60">
                  <rect x="8" y="5" width="60" height="60" />
                  <rect x="72" y="5" width="20" height="15" />
                  <rect x="72" y="25" width="130" height="15" />
                  <rect x="72" y="45" width="180" height="15" />
                </vue-content-loading>
                <vue-content-loading :width="300" :height="60">
                  <rect x="8" y="5" width="60" height="60" />
                  <rect x="72" y="5" width="120" height="15" />
                  <rect x="72" y="25" width="140" height="15" />
                  <rect x="72" y="45" width="40" height="15" />
                </vue-content-loading>
              </div>
            </div>
            <div class="stat" v-if="tabName == 'stats'">
              <Stats></Stats>
            </div>
          </Col>
        </Row>
      </Col>
    </Row>

    <UploadImageComponent ref="uploadImage" @emitBase64="onLoadImage"></UploadImageComponent>
  </AppLayout>
</template>

<script>
import UploadImageComponent from "@/components/UploadImageComponent";
import PagesListComponent from "@/components/PagesListComponent";
import CourseListComponent from "@/components/CourseListComponent";
import PostActivity from "@/components/PostActivityComponent";
import Followers from "@/components/ResourcesFollowersListComponent";
import ManageGroupComponent from "@/components/ManageGroupComponent";
import ModalHolder from "@/components/ModalHolderComponent";
import PendingInviteComponent from "@/components/PendingInviteComponent";
import PendingVolunteerComponent from "@/components/PendingVolunteerComponent";
import ModerationComponent from "@/components/ModerationComponent";
import Utils from "@/utils.js";
import VueContentLoading from "vue-content-loading";
import VuerMixin from "@/helpers/vuerMixin";
import ShareComponent from "@/views/ShareComponent";
import Stats from "@/components/statistics";
import * as API from "@/endpoints";
import { mapGetters } from "vuex";
import ModuleBottomComponent from "@/components/ModuleBottomComponent";
import CitationItem from "@/components/CitationItem";
import VueCookie from "vue-cookie";
import bookmarkImg from "@/assets/svg/bookmark-regular.svg";
import bookmarkSolidImg from "@/assets/svg/bookmark-solid.svg";
import _ from "lodash"

export default {
  name: "ModuleComponent",
  components: {
    CourseListComponent,
    PostActivity,
    Stats,
    CitationItem,
    Followers,
    ManageGroupComponent,
    ModalHolder,
    PendingInviteComponent,
    PendingVolunteerComponent,
    PagesListComponent,
    UploadImageComponent,
    VueContentLoading,
    ShareComponent,
    ModerationComponent,
    ModuleBottomComponent
  },
  data() {
    return {
      bookmarkImg,
      bookmarkSolidImg,
      isBookmarkingDoc: false,
      myPages: [],
      trackData: {
        elements: JSON.parse(
          VueCookie.get(
            `${Cons[0].PATHS.NAME}${Cons[0].PATHS.BRAND}CURRENT_MODULE_ELEMENTS`
          )
        ),
        documents: JSON.parse(
          VueCookie.get(
            `${Cons[0].PATHS.NAME}${Cons[0].PATHS.BRAND}CURRENT_MODULE_DOCUMENTS`
          )
        )
      },
      showSurveyIFrame: false,
      showDocInfo: false,
      selectedDoc: null,
      offsetNo: 84,
      viewSettings: false,
      tabName: "course",
      tabNameEdit: "manage",
      stickTabs: false,
      volunteerModal: false,
      permissions: Cons[0].PERMISSIONS,
      inviteModal: false,
      smsInvite: false,
      inviteOption: "facebook",
      applyVolunteerForm: {
        volunteerType: "admin",
        title: null,
        type: "apply_volunteer",
        timing: ["now"],
        data_type: "content",
        data: {
          permission: "16",
          qualification: "",
          status: "pending"
        },
        recurrence: [Utils.setRrulePostDate(new Date())]
      },
      statusSelect: [
        {
          value: "accepted",
          label: "Going"
        },
        {
          value: "interested",
          label: "Interested"
        },
        {
          value: "null",
          label: "Not going"
        }
      ],
      statusUser: "",
      previousStatusUser: "",
      statusDisable: false
    };
  },
  watch: {
    $route: function(n, o) {
      if (n) {
        if (!this.resourceLoading) {
          this.setTab(n);
        }
        this.viewSettings = n.query.edit ? true : false;
      }

      if (n.params.moduleId !== o.params.moduleId) {
        this.loadModule()
      }

      (this.trackData.elements = JSON.parse(
        VueCookie.get(
          `${Cons[0].PATHS.NAME}${Cons[0].PATHS.BRAND}CURRENT_MODULE_ELEMENTS`
        )
      )),
        (this.trackData.documents = JSON.parse(
          VueCookie.get(
            `${Cons[0].PATHS.NAME}${Cons[0].PATHS.BRAND}CURRENT_MODULE_DOCUMENTS`
          )
        ));
    },
    brandInfo(n) {
      this.loadModule()
    },
    resourceLoading: function(val) {
      this.setTab(this.$route);
    },
    tabName(n, o) {
      if (n && n === "documents") {
        this.$refs["courses"].pauseVideoExcept(null);
      }
    }
  },
  filters: {
    getTextFromHTML(html) {
      let parsed = new DOMParser().parseFromString(html, "text/html");
      return parsed.children[0].innerText;
    }
  },
  computed: {
    ...mapGetters("user", ["brandInfo"]),
    courseContactInfo() {
      console.log("magikeru", {
        contact_info: _.get(this.singleResource, "data.data.contact_info", ""),
        contact_info_title: _.get(this.singleResource, "data.data.contact_info_title", "")
      })
      return {
        contact_info: _.get(this.singleResource, "data.data.contact_info", ""),
        contact_info_title: _.get(this.singleResource, "data.data.contact_info_title", "")
      }
    },
    tocs() {
      return this.myPages.filter(e => {
        return e.type == "anchor";
      });
    },
    hasTOC() {
      return (
        this.myPages.filter(e => {
          return e.type == "anchor";
        }).length > 0
      );
    },
    isHideTabs() {
      return this.$route.query.tabHide ? true : false;
    },
    isFloatingModule() {
      return this.$route.query.floating ? true : false;
    },
    hasCitationId() {
      if (
        !("data" in this.singleResource.data) ||
        !("citation_id" in this.singleResource.data.data) ||
        !this.singleResource.data.data.citation_id
      )
        return null;
      return this.singleResource.data.data.citation_id;
    },
    brandId: {
      get() {
        return this.$store.state.resource.singleResource.data.developed_by;
      }
    },
    singleResource: {
      get() {
        return this.$store.state.resource.singleResource;
      }
    },
    moduleCoverPhoto(){
      return (this.singleResource.data && this.singleResource.data.thumbnail_photo_uri) ? process.env.VUE_APP_BASE_IMAGE_URL+'large'+this.singleResource.data.thumbnail_photo_uri : this.singleResource.data.thumbnail_photo[0].large;
    },
    groupFeed: {
      get() {
        return this.$store.state.resource.groupFeed;
      }
    },
    isElementsLoading() {
      return this.isGroupFeedLoading || this.isLoadingElements;
    },
    profileInfo: {
      get() {
        return this.$store.state.user.info;
      }
    },
    postImageFile: {
      get() {
        return this.$store.state.publicModule.uploadedImage;
      }
    },
    ...mapGetters("user", ["isBroadcast"]),
    ...mapGetters("resource", [
      "isLoadingDocs",
      "resourceLoading",
      "isGroupFeedLoading"
    ]),
    ...mapGetters("library", ["isLoadingElements"]),
    moduleDocs() {
      return this.$store.state.library.trackData.documents;
    }
  },
  methods: {
    elementSort(hasLocalPackage, elements) {
      let sorted = _.orderBy(elements, 'order', 'asc');
      let moduleId = this.$route.params.moduleId;
      let groupedElements = _.groupBy(sorted, "careplan_id")

      if (hasLocalPackage){
        let withLocalPackage = _.orderBy(groupedElements[hasLocalPackage], 'order', 'asc')
        let hasTop = withLocalPackage[0] ? withLocalPackage[0].order == 0 : false
        if (groupedElements[moduleId] && groupedElements[moduleId].length > 0)
          withLocalPackage.splice(hasTop ? 1 : 0, 0, ..._.orderBy(groupedElements[moduleId], 'order', 'asc'))
        return withLocalPackage
      }
      else {
        return sorted;
      }
    },
    bookmarkItem(item) {
      if (this.profileInfo.user_type !== "guest") {
        this.isBookmarkingDoc = true
        this.$store.dispatch("feed/bookmarkItem", { item }).then(
          res => {
            if (!item.bookmarked) {
              item.bookmarked = 1;
              item.bookmark_id = res.id
            } else {
              item.bookmarked = 0;
            }
            this.isBookmarkingDoc = false
          },
          err => {
            this.isBookmarkingDoc = false
          }
        );
      } else {
        this.$store.commit("hitCheckpoint");
      }
    },
    scrollTo(id) {
      // document.getElementById(id).scrollIntoView({ behavior: "smooth" })
      const yOffset = -150;
      const element = document.getElementById(id);
      const y =
        element.getBoundingClientRect().top + window.pageYOffset + yOffset;

      window.scrollTo({top: y, behavior: 'smooth'});
      element.children[0].children[1].classList.add("blink")
      setTimeout(() => {
        element.children[0].children[1].classList.remove("blink")
      }, 3000);
    },
    titleFormat(text) {
      return _.kebabCase(text);
    },
    getModuleItems() {
      var res = this.$store.dispatch(
        "library/getModuleItems",
        this.$route.params.moduleId
      );

      res.then(b => {
        this.myPages = _.orderBy(b.data.pages, 'order', 'asc');
        if (b.data.type == "resource") {
          this.$router.replace({
            query: {
              ...this.$route.query,
              tabHide: true
            }
          });
        }
      });
    },
    documentClick(item) {
      if (
        this.removeHTMLTags(item.data.tip) &&
        this.removeHTMLTags(item.data.tip).length > 100
      ) {
        this.$router.push("/feed/" + item.id + "?isDocuments=true");
      } else {
        this.selectedDoc = item;
        this.showDocInfo = true;
      }

      this.$store.dispatch('statistics/postStats', {stat_type: 'activity_action', stat_id: item.id, link_tag: 'View course item additional resources'});
      
      if (!this.isFloatingModule) {
        let engageCourse = JSON.parse(
          VueCookie.get(
            `${Cons[0].PATHS.NAME}${Cons[0].PATHS.BRAND}ENGAGE_COURSE`
          )
        );
        this.$store.dispatch(
          "points/setUserActionPoints",
          {
            action: "view_post",
            element_id: item.id,
            user_story_id: engageCourse.userStory,
            track_id: engageCourse.course,
            module_id: engageCourse.article,
            category: engageCourse.category
          },
          { root: 1 }
        );
      } else {
        this.$store.dispatch(
          "points/setUserActionPoints",
          {
            action: "view_post",
            element_id: item.id
          },
          { root: 1 }
        );
      }
    },
    removeHTMLTags(data) {
      if (data) return data.replace(/<\/?[^>]+(>|$)/g, "");
    },
    selectedDocItem(v) {
      this.selectedDoc = v;
      this.showDocInfo = true;
    },
    onShowSurveyIFrame(v) {
      // console.log(this.$route.path, this.$route.query)
      // let path = this.$route.path;
      // let query = this.$route.query;
      // query.showsurvey = true;
      // this.$router.replace(path + "?tab="+this.$route.query.tab+"&showsurvey=true")
      this.showSurveyIFrame = true;
      let engageCourse = JSON.parse(
        VueCookie.get(
          `${Cons[0].PATHS.NAME}${Cons[0].PATHS.BRAND}ENGAGE_COURSE`
        )
      );
      this.$store.dispatch(
        "points/setUserActionPoints",
        {
          action: "take_survey",
          user_story_id: engageCourse.userStory,
          track_id: engageCourse.course,
          module_id: engageCourse.article,
          category: engageCourse.category
        },
        { root: 1 }
      );
    },
    onPreviewText(v) {
      // console.log(v);
      return v;
      // return v.replace(/(<([^>]+)>)/gi, '')
    },
    getDisplayImage(data) {
      return Utils.getDisplayImage("group", data, "small");
    },
    statusClick(v) {
      if (
        this.$store.state.user.info &&
        this.$store.state.user.info.user_type === "guest"
      ) {
        this.$store.commit("hitCheckpoint");
        return false;
      }

      if (this.previousStatusUser != v) {
        this.statusDisable = true;
        if (v == "accepted") {
          this.$store
            .dispatch("events/joinEvent", this.singleResource.data.id)
            .then(
              res => {
                this.statusDisable = false;
              },
              error => {
                this.statusDisable = false;
              }
            );
        } else if (v == "null") {
          if (
            this.singleResource.data.invite_id &&
            this.singleResource.data.subscribed
          ) {
            this.$store
              .dispatch(
                "events/declineEvent",
                this.singleResource.data.invite_id
              )
              .then(
                res => {
                  this.statusDisable = false;
                },
                error => {
                  this.statusDisable = false;
                }
              );
          } else {
            this.followGroup();
            this.statusDisable = false;
          }
        } else if (v == "interested") {
          if (this.singleResource.data.invite_id) {
            this.$store
              .dispatch(
                "events/setInterestedEvent",
                this.singleResource.data.invite_id
              )
              .then(
                res => {
                  this.statusDisable = false;
                },
                error => {
                  this.statusDisable = false;
                }
              );
          } else {
            this.followGroup();
            this.statusDisable = false;
          }
        } else {
          setTimeout(() => {
            this.statusDisable = false;
          }, 1000);
        }
        this.previousStatusUser = v;
      }
    },
    editMode() {
      this.$router.push({
        path: this.$route.path,
        query: {
          tab: this.$route.query.tab || "posts",
          edittab: this.$route.query.edittab || "manage",
          edit: 1
        }
      });
    },
    followBrand() {
      if (!this.singleResource.data.subscribed) {
        this.$store
          .dispatch("resource/followBrandGroup", {
            group: this.singleResource.data,
            userId: this.profileInfo.id,
            type: "follow"
          })
          .then(res => {
            this.singleResource.data.subscribed = true;
          });
      } else {
        this.$store
          .dispatch("resource/followBrandGroup", {
            group: this.singleResource.data,
            userId: this.profileInfo.id,
            type: "unfollow"
          })
          .then(res => {
            this.singleResource.data.subscribed = false;
          });
      }
    },
    checkIfUserCanPost(data) {
      if (data.members_can_post) {
        return true;
      } else {
        if (
          data.permission &&
          "permission" in data.permission &&
          data.permission.permission == 0
        )
          return true;
        if (
          data.permission &&
          "permission" in data.permission &&
          data.permission.permission == 511
        )
          return true;
        if (
          data.permission &&
          "permission" in data.permission &&
          data.permission.permission == 503
        )
          return true;
        if (
          data.permission &&
          "permission" in data.permission &&
          data.permission.permission == 16
        )
          return true;
        if (
          data.permission &&
          "permission" in data.permission &&
          data.permission.permission == 49
        )
          return true;
      }

      return false;
    },
    checkIfUserCanUpdateGroup(data) {
      if (data.permission) {
        if ("permission" in data.permission) {
          if (
            data.permission.permission == 511 ||
            data.permission.permission == 503 ||
            data.permission.permission == 99 ||
            data.permission.permission == 0
          )
            return true;
        }
      }
    },
    isUserAdmin(data) {
      if (data.permission) {
        if ("permission" in data.permission) {
          if (
            data.permission.permission == 511 ||
            data.permission.permission == 503 ||
            data.permission.permission == 0
          )
            return true;
        }
      } else {
        return false;
      }
    },
    change(status) {
      this.stickTabs = status;
    },
    setTab(n) {
      if ("tab" in n.query && n.query.tab) this.tabName = n.query.tab;
    },
    onTabClick(name) {
      // console.log(name)
      // if(name == 'info'){
      //   this.reRoutToInfo()
      // }
      if ("type" in this.$route.query && this.$route.query.type)
        this.$router.replace({
          query: {
            ...this.$route.query,
            tab: name,
            type: this.$route.query.type
          }
        });
      else this.$router.replace({ query: { ...this.$route.query, tab: name } });
    },
    onEditTabClick(name) {
      // console.log(name)
      // if(name == 'info'){
      //   this.reRoutToInfo()
      // }
      if ("type" in this.$route.query && this.$route.query.type) {
        this.$store.dispatch('statistics/postStats', {stat_type: 'activity_action', stat_id: this.$route.params.moduleId, link_tag: `View Courses Tab`});
        this.$router.replace({
          query: {
            edittab: name,
            type: this.$route.query.type,
            tab: this.$route.query.tab
          }
        });
      } else {
        this.$store.dispatch('statistics/postStats', {stat_type: 'activity_action', stat_id: this.$route.params.moduleId, link_tag: `View Additional Resources Tab`});
        this.$router.replace({
          query: {
            edittab: name,
            tab: this.$route.query.tab,
            edit: this.$route.query.edit
          }
        });
      }
    },
    onSubmitVolunteer() {
      if (this.applyVolunteerForm.data.qualification) {
        this.applyVolunteerForm.title = this.profileInfo.display_name;
        this.$store
          .dispatch("resource/postUpdateVolunteer", {
            data: this.applyVolunteerForm,
            id: this.singleResource.data.id
          })
          .then(res => {
            this.volunteerModal = false;
            this.$Message({
              closable: true,
              durationInSec: 10,
              title: { content: "Sent" },
              icon: "checkmark",
              message: { content: "Application sent." },
              buttons: [
                {
                  label: "Ok",
                  type: "primary",
                  hideAfter: true,
                  action: () => next()
                }
              ]
            });
          });
      } else {
        this.$Message({
          closable: true,
          durationInSec: 10,
          title: { content: "Required" },
          icon: "ios-close",
          message: { content: "Missing qualification content." },
          buttons: [
            {
              label: "Ok",
              type: "primary",
              hideAfter: true,
              action: () => next()
            }
          ]
        });
      }
    },
    checkIfCreator(id) {
      return !(id == this.profileInfo.id);
    },
    followGroup() {
      if (
        this.$store.state.user.info &&
        this.$store.state.user.info.user_type === "guest"
      ) {
        this.$store.commit("hitCheckpoint");
        return false;
      }

      if (!this.singleResource.data.subscribed) {
        this.$store.dispatch("resource/followGroup", {
          careplan_id: this.singleResource.data.id,
          journal_id: this.profileInfo.journal_id
        });
      } else {
        this.$store.dispatch(
          "resource/unfollowGroup",
          this.singleResource.data.id
        );
      }
    },
    closeSmsModal() {
      this.smsInvite = false;
      this.inviteModal = true;
    },
    closeModal() {
      this.volunteerModal = false;
      this.inviteModal = false;
      this.smsInvite = false;
    },
    onShare() {
      if (this.inviteOption == "sms") {
        this.inviteModal = false;
        this.smsInvite = true;
      } else if (this.inviteOption == "facebook") {
        this.triggerFbShare();
      }
      // this.inviteModal = false
    },
    triggerFbShare($event) {
      // this.$store.dispatch('share/getBrandShareInfo', {brand_id: this.singleResource.data.developed_by, user_id: this.profileInfo.id}).then(res => {
      const elem = this.$refs.shareFbButton;
      elem.$el.children[0].click();
      // });
    },
    uploadImage() {
      this.$refs.uploadImage.triggerUpload();
    },
    onLoadImage(image) {
      this.$store
        .dispatch("publicModule/uploadBase64Image", { base64_image: image })
        .then(res => {
          if (!_.isEmpty(this.postImageFile)) {
            let imageContainer = this.singleResource.data.thumbnail_photo;
            this.singleResource.data.thumbnail_photo = this.postImageFile.uploaded[0];
            this.onChangeImage(imageContainer, image);
          }
        });
    },
    onChangeImage(oldImage, newImage) {
      this.$store
        .dispatch("resource/updateGroupInfo", {
          id: this.singleResource.data.id,
          data: this.singleResource.data
        })
        .then(res => {
          this.singleResource.data.thumbnail_photo = oldImage;
          this.singleResource.data.thumbnail_photo[0].small = newImage;
          this.$Message({
            closable: true,
            durationInSec: 10,
            title: { content: "Updated" },
            icon: "alert",
            message: { content: "Group avatar updated." },
            buttons: [
              {
                label: "Ok",
                type: "primary",
                hideAfter: true,
                action: () => next()
              }
            ]
          });
        });
    },
    reRoutToInfo() {
      if (this.singleResource.data.pages.length == 1) {
        this.$store.commit(
          "feed/setSingleFeed",
          this.singleResource.data.pages[0]
        );
        this.$router.push({
          path:
            "/feed/" + this.singleResource.data.pages[0].id + "?scroll=false"
        });
      }
    },
    dateToPrettyFormat(date) {
      return Utils.parseDateToPrettyFormat(date);
    },
    timeTo12HourFormat(time) {
      return Utils.parseTimeTo12Hr(time);
    },
    loadModule() {
      this.stickTabs = false;

      this.$store
        .dispatch("resource/getSingleResourceModule", {
          id: this.$route.params.moduleId
        })
        .then(res => {
          this.myPages = this.elementSort(res.data.local_module_id, res.pages)
          this.$router.replace({
            query: {
              ...this.$route.query,
              title: this.singleResource.data.title
            }
          });
          this.$store.commit("setPageTitle", this.singleResource.data.title);
        });

      if (this.isFloatingModule) {
        this.getModuleItems();
      }
    }
  },
  mounted() {
    this.setTab(this.$route);

    if (
      "type" in this.$store.state.mobileView &&
      this.$store.state.mobileView.type === "android"
    )
      this.offsetNo = 0;
    if (
      "type" in this.$store.state.mobileView &&
      this.$store.state.mobileView.type === "ios"
    )
      this.offsetNo = 0;

    this.loadModule()  
  },
  mixins: [VuerMixin]
};
</script>
